export enum Auth {
    ADMIN = 'admin',
    USERS = 'users',
}
